import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function tasktypeApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTaskType`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function taskstatusApi() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTaskStatus`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllTaskList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllTaskPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers?page=${page}&limit=${limit}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllTaskSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllTaskPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllTasksByReportingUsers?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllRelatedTask(type, id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllRelatedTasks/${type}/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TaskDeatailsApi(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByTaskId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TasksSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createTasks`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TaskUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateTasks/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function massUpdateTask(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/massUpdateTask`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteTasks(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteTasks`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    massUpdateTask,
    massDeleteTasks,
    tasktypeApi,
    taskstatusApi,
    AllTaskList,
    AllRelatedTask,
    TaskUpdate,
    AllTaskPagination,
    AllTaskPaginationSearch,
    FetchAllTaskSearch,
    TaskDeatailsApi,
    TasksSave,
}